<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    {{getDemoUrlDetail}}
    <div class="form-group">
      <label class="label-form">Label<span style="color: red">*</span>:</label>
      <input class="form-control"  type="text" v-model="video_label"/>
      
    </div>
    <div class="form-group">
      <label class="label-form">URL<span style="color: red">*</span>:</label>
      <input class="form-control"  type="text" v-model="video_link"/>
      
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      
      <button v-if="flag"  type="button" class="btn btn-secondary" data-dismiss="modal">
        Close
      </button>
      <button v-else type="button"  :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-secondary" backdrop= "static" keyboard = "false" @click="cancel">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Cancel
      </button>



      <button v-if="flag" type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-default  ml-1" @click="save">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Save
      </button>

      <button v-else type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-default ml-1 text-light" @click="updateDemoUrlLink">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Update
      </button>

    </div>

<table class="table table-bordered table-hover  mt-5 text-center">
            <colgroup>
              <col class="col-md-4" />
              <col class="col-md-12" />
            </colgroup>
            <tbody>
              <tr>
                <th>label</th>
                <th>URL</th>
                <th>Action</th>
              </tr>
              
              <tr class="mt-2" v-for="(demo, index) in demo_url" :key="demo.id">
                
                <td  style="width: 60%;"> <p style="white-space: break-spaces; word-break: break-word;">{{ demo.label }}</p> </td>
                <td  style="width: 30%;"> <p style="white-space: break-spaces; word-break: break-word;">{{ demo.video_link }}</p> </td>
                <td  style="width: 10%;">
                  <div class="btn-group">
                    <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                      <span class="fas fa-ellipsis-v"></span>
                    </a>
                    <ul class="dropdown-menu" style="min-width: 12rem !important">
                      <a class="dropdown-item" @click="updateVideoUrl(index)">Edit</a>
                      <a class="dropdown-item " style="color: rgb(247, 7, 7);" @click="deleteurl(demo.id)">Delete</a>
                    </ul>
                  </div>
                </td>
              </tr>
              <h5 style="text-align: center; position: absolute; transform: translateX(180px); margin-top: 24px;" v-if="demo_url.length<1">
      No Url's found.
    </h5>
            </tbody>
          </table>



  </form>

</template>
<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";

  export default {
    props: ["action", "formData", "pageNumber"],
    data: function () {
      return {
        isMiniLoading: false,
        video_label: "",
        video_link:"",
        demo_url:"",
        emptydata:false,
        id:"",
        flag: true,
      };
    },
   

    computed: {
      getDemoUrlDetail: function () {
        this.video_label = "";
        this.video_link = "";

        axios
          .get("admin/organization/demo_urls?org_id=" + this.formData.org_id)
          .then((response) => {
            let data = response.data.demo_url;
            if (data != null) {
              this.demo_url = data;
            }
            this.flag = true;
          });
      },
    },


    methods: {
      save() {
        this.isMiniLoading = true;
        let video_label = this.video_label;
        let video_link = this.video_link;
        if(this.video_label==""){
              this.$toast.warning("Please Fill Label Field.");  
          }
          if(this.video_link==""){
              this.$toast.warning("Please Fill Url Field.");  
                

          }
        if(!/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(video_link)){
           this.isMiniLoading = false;
           this.$toast.error('Please enter a valid URL');
        }
        else if (video_label.replace(/\s/g, "").length && video_link.replace(/\s/g, "").length) {
          this.$store
            .dispatch("organizations/postVideoLink", [this.formData.org_id,video_label,video_link])
            .then(() => {
              this.isMiniLoading = false;
              this.getdemourls();
              this.$toast.success("Video link has been uploaded successfully");
              this.getdemourls();
              this.video_label="";
              this.video_link="";
            });
          // window.$("#modal").modal("hide");
          
        
        } else {
          
          this.isMiniLoading = false;
        }
      },
      cancel(){
        this.video_label="";
        this.video_link="";
          this.flag=true;
        },
      updateVideoUrl(url_id) {
        this.id = this.demo_url[url_id].id;
        this.video_label = this.demo_url[url_id].label;
        this.video_link = this.demo_url[url_id].video_link;
        this.flag = false;
      },


      updateDemoUrlLink() {
         this.isMiniLoading = true;
        let video_label = this.video_label;
        let video_link = this.video_link;
        if(video_label==""){
              this.$toast.warning("Please Fill Label Field.");  
          }
          if(video_link==""){
              this.$toast.warning("Please Fill Url Field.");  
          }
        if(!/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(video_link)){
           this.isMiniLoading = false;
           this.$toast.error('Please enter a valid URL');
        }
        else if (video_label.replace(/\s/g, "").length && video_link.replace(/\s/g, "").length) {
          this.$store
            .dispatch("organizations/updateVideoLink", [this.id,video_label,video_link])
            .then(() => {
              this.isMiniLoading = false;
              this.getdemourls();
              this.$toast.success("Video link has been Updated successfully");
              this.getdemourls();
              this.video_label="";
              this.video_link="";
              this.flag = true;
            });
          // window.$("#modal").modal("hide");
          
        
        } else {
          this.isMiniLoading = false;
          // this.$toast.warning("Please Fill All Required Fields");
        }
      },



      deleteurl(url_id){
         axios.get("/admin/organization/demo_urls?url_id=" + url_id)
          .then((response) => {
            this.$toast.error(response.data.message);
            this.getdemourls();
          });
      },

      getdemourls() {
        axios
          .get("/admin/organization/demo_urls?org_id=" + this.formData.org_id)
          .then((response) => {
            let data = response.data.demo_url;
            if (data != null) {
              this.demo_url = data;
            }
           
          });
      },

    },
  };
</script>